import { render } from "./jiagouInfo.vue?vue&type=template&id=af5d1eaa&scoped=true&ts=true"
import script from "./jiagouInfo.vue?vue&type=script&lang=ts"
export * from "./jiagouInfo.vue?vue&type=script&lang=ts"

import "./jiagouInfo.vue?vue&type=style&index=0&id=af5d1eaa&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af5d1eaa"]])

export default __exports__